export { WPAPI } from "./wpapi_reducer";
export { i18nState } from "redux-i18n";
export { language } from './language_reducer';
export { search } from './search_reducer';
export { navbar } from './navbar_reducer';
export { downloadItem } from './download_item_reducer';

export const gravityFormsApi = ( state = {} ) => {
  return state;
};



// WEBPACK FOOTER //
// ./src/redux/reducer/reducers.js